import shortid from 'shortid';
import Hashids from 'hashids';

import { tryToResendVerificationEmail } from './actions.export';

var hashids = new Hashids('k100p');

export const addToast = data => dispatch => {

  if(!data.id) data.id = shortid.generate();

  dispatch(addToastToReducer(data));

  if(data.autoDismiss){
    setTimeout((e)=>{
      dispatch(dismissToast({id: data.id }));
    }, data.autoDismiss);
  }
}

export const addVerifyEmailToast = data => (dispatch, getState) => {

  let user = getState().user;

  let sentence = "Please click the link in your welcome email (" + user.email + "). You won't be able to access all free abilities until your email is verified.";

  if(user.roles.pro){
    sentence = "Please click the link in your welcome email (" + user.email + ") to verify your email address.";
  }

  dispatch(addToast({
    title: "Verify your email! 💌",
    id: 'verify',
    detail: sentence,
    buttons: [
      {
        display: "Resend",
        dismissOnClick: true,
        onClick: (e) => {
          dispatch(tryToResendVerificationEmail());
        }
      },
      {
        display: "Settings",
        destination: '/settings/my-account/email/verify'
      }
    ]
  }))
}

export const addDelinquentUserToast = data => (dispatch, getState) => {

  let sentence = "Your payment method needs to be updated and past due invoice paid in order to continue using Pro features.";

  dispatch(addToast({
    title: "⚠️ Payment Failure",
    id: 'delinquent_user',
    detail: sentence,
    buttons: [
      {
        display: "Billing Settings",
        destination: '/settings/my-account/billing/payment-methods'
      }
    ]
  }))
}

export const addDelinquentTeamToast = data => (dispatch, getState) => {

  let sentence = "Your payment method needs to be updated.";

  let myRole = data.team.myRole;

  if(myRole == 'admin'){
    dispatch(addToast({
      title: "⚠️ Payment Failure for " + data.team.display_name,
      id: 'delinquent_team_' + data.team.id,
      detail: sentence,
      buttons: [
        {
          display: "Team Settings",
          destination: '/settings/' + (data.team.isEnterprise ? 'enterprise' : 'firm') + '/' + hashids.encode(data.team.id) + '/billing/payment-methods'
        }
      ]
    }))
  } else if(myRole == 'member'){
    dispatch(addToast({
      title: "⚠️ Payment Failure for " + data.team.display_name,
      id: 'delinquent_team_' + data.team.id,
      detail: sentence + " Please contact your team's administrator.",
      buttons: [
        {
          display: "Dismiss",
          dismissOnClick: true
        }
      ]
    }))
  }

}


export const addToastToReducer = data => ({
  type: 'ADD_TOAST',
  data
})


export const dismissToast = data => ({
  type: 'DISMISS_TOAST',
  data
})



// WEBPACK FOOTER //
// ./src/actions/actions.toast.js